import { accountDelete } from './accountDelete';
import { accountSettings } from './accountSettings';
import { authorization } from './authorization';
import { authUser } from './authUser';
import { bloodTestForm } from './bloodTestForm';
import { bottomNavigation } from './bottomNavigation';
import { dashboard } from './dashboard';
import { dialogPage } from './dialogPage';
import { evaluation } from './evaluation';
import { explore } from './explore';
import { externalPartner } from './externalPartner';
import { feedback } from './feedback';
import { goPay } from './goPay';
import { healthInsuranceProviderBenefit } from '@/feature/health-insurance-benefits/store/healthInsuranceProviderBenefit';
import { invitation } from './invitation';
import { login } from './login';
import { medicalProcedure } from './medicalProcedure';
import { phoneVerification } from './phoneVerification';
import { prevention } from './prevention';
import { reauthorization } from './reauthorization';
import { registration } from './registration';
import { service } from './service';
import { thematicCounselling } from './thematicCounselling';
import { userAppData } from './userAppData';

export const profile = {
  namespaced: true,
  modules: {
    accountDelete,
    accountSettings,
    authorization,
    authUser,
    bloodTestForm,
    bottomNavigation,
    dashboard,
    dialogPage,
    evaluation,
    explore,
    externalPartner,
    feedback,
    goPay,
    healthInsuranceProviderBenefit,
    invitation,
    login,
    medicalProcedure,
    phoneVerification,
    prevention,
    reauthorization,
    registration,
    service,
    thematicCounselling,
    userAppData
  }
};
